import { gql } from '@apollo/client/core';

const PortfolioConnectionRequestsQuery = gql`
  query PortfolioConnectionRequests($slug: String!) {
    portfolioConnectionRequests: publicPortfolioUser(slug: $slug) {
      connected
      incomingConnectionRequest {
        id
        status
      }
      outgoingConnectionRequest {
        id
        status
      }
    }
  }
`;

export default PortfolioConnectionRequestsQuery;
